import { Base } from "ui/Scripts/source/framework/base";
import { ListItems } from "ui/Scripts/source/framework/listItems";
import { IUserListItem, UserListItem } from "./userListItem";

export interface IUserListItems extends ListItems<IUserListItem> {
    companyCanUseInstantMessages: boolean;
}

export class UserListItems extends ListItems<UserListItem> implements IUserListItems {
    companyCanUseInstantMessages: boolean;

    constructor();
    constructor(obj: IUserListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, UserListItem);
        this.companyCanUseInstantMessages = obj && obj.companyCanUseInstantMessages || false;
    }
}